export default "__VITE_ASSET__BRZLYrWo__"